module.exports = __webpack_public_path__ + "static/media/mobilebg1.08ebeb29.jpg";